import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { firstValueFrom, map, Observable, startWith, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { ChatService } from '../../service/chat-service';
import { UserProfile } from '../../model/rolePlay.model';
import { EncryptionService } from '../../service/encryption/encryption.service';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder } from '@angular/forms';
import { MatOptionSelectionChange } from '@angular/material/core';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { InteractionService } from '../../service/interaction/interaction.service';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GRAPH_ENDPOINT_PROFILE_IMAGE } from '../../utility/constant-config';
import { ProductPlatform } from '../../model/shared/platform-region.model';
import { PlatformRegionService } from '../../service/shared/platform-region.service';
import { UserProfileResponse } from '../../model/shared/user.model';

@Component({
    selector: 'app-profile-info',
    templateUrl: './profile-info.component.html',
    styleUrl: './profile-info.component.scss',
    providers: [
        {
            provide: MAT_SELECT_CONFIG,
            useValue: { overlayPanelClass: 'custom-multi-select-panel' },
        },
    ],
    standalone: false
})
export class ProfileInfoComponent {
  userId: number = 0;
  userProfile!: UserProfileResponse;
  profileImageUrl: string;
  isExistProfileImage: boolean;

  constructor(private http: HttpClient, public ChatService: ChatService, public Router: Router, public dialogRef: MatDialogRef<ProfileInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private encryptionService: EncryptionService, public fb: FormBuilder,
    public intService: InteractionService, private readonly toastr: ToastrService, private platformRegionService: PlatformRegionService) { }

  async ngOnInit() {
    this.getProfileImage();
    this.userProfile = await firstValueFrom(this.ChatService.getUserProfileByWWID());
    this.platformRegionService.productPlatformList = this.userProfile.product;
  }

  getProfileImage() {
    let accessToken = "";
    const userEmail = sessionStorage.getItem("userEmail");
    // MSAL's own token cache now lives in localStorage (cacheLocation: LocalStorage)
    for (let key in localStorage) {
      if (key.includes('accesstoken')) {
        let obj = localStorage.getItem(key);
        let jsonObj = JSON.parse(obj);
        const helper = new JwtHelperService();
        accessToken = helper.decodeToken(jsonObj.secret);
      }
    }

    const headers = new HttpHeaders({
      'Authorization': `Bearer ${accessToken}`
    });

    this.http.get(`${GRAPH_ENDPOINT_PROFILE_IMAGE}`, { responseType: 'blob', headers })
      .subscribe(blob => {
        this.profileImageUrl = URL.createObjectURL(blob);
        this.isExistProfileImage = !!this.profileImageUrl;
      }, error => {
        this.isExistProfileImage = false;
        console.error('Error fetching photo:', error);
        if (error.error) {
          console.log('Error details:', error.error);
        }
      });
  }

  backbutton() {
    this.Router.navigate(['/app-abiomed-chat'], { skipLocationChange: true });
  }


  closeDialog(): void {
    this.dialogRef.close();
  }
}